module.exports = __webpack_public_path__ + "f641a7d4e80fd6321135b1a2b4ce8bb1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Regular/OpenSans-Regular.svg?v=1.1.0
// module id = 986
// module chunks = 0